export default "__VITE_ASSET__DmR$FdGh__"